import Vue from "vue";
import pluralize from "pluralize";
import titleCase from "voca/title_case";
import words from "voca/words";
import truncate from "voca/truncate";
import nl2br from "nl2br";

export const titleCaseFilter = function ( value, ignoreTinyWords = true ) {
	if ( !value ) {
		return "";
	}
	const tinyWords = {
		a: true,
		an: true,
		and: true,
		as: true,
		at: true,
		but: true,
		by: true,
		en: true,
		for: true,
		if: true,
		in: true,
		nor: true,
		of: true,
		on: true,
		or: true,
		per: true,
		the: true,
		to: true,
		vs: true,
		"vs.": true,
		via: true,
	};

	return words( value, /[^\s]+/g )
		.map( word => {
			if ( ignoreTinyWords && tinyWords[ word ] ) {
				return word;
			}
			return titleCase( word );
		} )
		.join( " " );
};

export const pluralizeFilter = function( count, string, showCount = true ) {
	if ( !count ) {
		return `No ${string}`;
	}
	return pluralize( string, count, showCount );
};

export const truncateText = ( str, length = 100, ending = "..." ) => {
	return truncate( str || "", length, ending );
};

export const _nl2br = ( str = "" ) => {
	return nl2br( str );
};

Vue.filter( "pluralize", pluralizeFilter );
Vue.filter( "titleCase", titleCaseFilter );
Vue.filter( "truncate", truncateText );
Vue.filter( "nl2br", _nl2br );



// WEBPACK FOOTER //
// ./src/filters/string.js